import React from "react";
import { withQuery, Pill, Button } from "components/common";
import { BOOST_LANDING_CC_QUERY } from "utils/mutations";
import { toEmoji } from "utils/tomoEmoji";

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const BoostLandingCreditCardUser = ({ data, user }) => {
  const link = `${process.env.REACT_APP_DOMAIN}/dashboard/boost/pricing?email=${encodeURIComponent(user.email)}`;
  const { first_name, credit } = data?.simpleUser || {};
  const { credit_limit = 0 } = credit || {};

  return (
    <div className="w-full h-full bg-black" style={{ minWidth: 350 }}>
      <div className="pt-20 px-10 box-content mx-auto max-w-sm flex flex-col shrink-0 justify-center items-center text-white">
        <div className="self-start text-xl font-semibold">Hi {first_name}!</div>
        <div className="mt-4 text-5xl font-bold text-white">
          Tomo<span className="text-boost-light-purple">Boost</span>
        </div>
        <div className="flex justify-center">
          <Pill
            pillColor="bg-green-primary"
            label="Active"
            fontColor="text-black"
            className="font-semibold px-8 mr-2"
            style={{ "margin-right": 0, "margin-bottom": "10px" }}
          />
        </div>
        <div className="mt-6 font-semibold text-md self-start">
          <div>
            <span className="text-boost-light-purple">Your Credit Line: </span>$
            {numberWithCommas(credit_limit)}
          </div>
          <div className="mt-4">
            <span className="text-boost-light-purple">Reporting to: </span>
            TransUnion®, Experian®, Equifax®
          </div>
        </div>
        <div
          className="mt-10 flex flex-col space-y-3 px-8 py-5 rounded-sm text-sm font-extralight"
          style={{ backgroundColor: "#2B185F" }}
        >
          <div className="flex items-center text-left">
            <span className="mr-6 flex shrink-0">{toEmoji("⚠️")}</span>
            <span>
              As of 9/26/23 your card will{" "}
              <span className="font-semibold">stop working</span>.
            </span>
          </div>
          <div className="flex items-center text-left">
            <span className="mr-6 flex shrink-0">{toEmoji("✅")}</span>No
            negative impact to your credit.
          </div>
          <div className="flex items-center text-left">
            <span className="mr-6 flex shrink-0">{toEmoji("🙌")}</span>
            <span className="">
              Your current credit line will{" "}
              <span className="font-semibold">continue to be reported</span> to
              all three bureaus.
            </span>
          </div>
        </div>
        <div className="mt-8">
          <a href={link} className="inline-block">
            <Button
              className="my-4 rounded-xl"
              buttonColor="white"
              shadow="0px 0px 10px 3px #8154FE"
              buttonTextColor="#4B2BA3"
              paddingHorizontal={40}
              paddingVertical={8}
            >
              <span className="text-xl font-semibold whitespace-nowrap">
                Report a Higher Line
              </span>
            </Button>
          </a>
        </div>
        <div className="mt-10 mb-6 mx-5 text-white text-xl font-semibold text-left space-y-6 whitespace-nowrap">
          <div>
            <i className="mr-2 my-1 fa-solid fa-check" />
            <span className="text-boost-light-purple relative">
              <span className="absolute text-xxs -mt-3">Up To</span>
              <span className="text-white">
                $30,000{" "}
                <span className="text-boost-light-purple">of Credit Line</span>
              </span>
              .
            </span>
          </div>
          <div>
            <i className="mr-2 my-1 fa-solid fa-check" />
            <span className="text-boost-light-purple">
              No Credit Check.
            </span>{" "}
            EVER.
          </div>
          <div>
            <i className="mr-2 my-1 fa-solid fa-check" />
            100%{" "}
            <span className="text-boost-light-purple">Instant Approval</span>.
          </div>
        </div>
        <div
          className="border-green-primary my-2 rounded-lg"
          style={{
            width: "140px",
            height: "2px",
            borderWidth: "1px",
          }}
        />
        <div
          className="mt-8 mb-40 flex flex-col space-y-3 leading-tight px-8 py-5 rounded-sm text-sm font-extralight"
          style={{ backgroundColor: "#004337" }}
        >
          <div className="flex items-center">
            <span className="mr-4 flex shrink-0">{toEmoji("💳")}</span>You still
            owe what you spent on your card.
          </div>
          <div className="flex items-center">
            <span className="mr-4 flex shrink-0">{toEmoji("✅")}</span>You have
            full access to your dashboard.
          </div>
          <div className="flex items-center">
            <span className="mr-4 flex shrink-0">{toEmoji("🥇")}</span>You will
            be the 1st to be notified of our upcoming features and services.
          </div>
        </div>
      </div>
    </div>
  );
};

export default withQuery(BOOST_LANDING_CC_QUERY)(BoostLandingCreditCardUser);
